import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Operations from '@/views/Operations'
import Todo from '@/views/Todo'
import Leads from '@/views/Leads'
import Rdv from '@/views/Rdv'
import Medias from '@/views/Medias'
import Statistique from '@/views/Statistique'
import Account from '@/views/Account'
import EditLead from '@/views/EditLead'
import CreateLead from '@/views/CreateLead'
import Details from '@/views/Details'
import CreateRdv from '@/views/CreateRdv'
import AddRdv from '@/views/AddRdv'
import RepriseForm from '@/views/RepriseForm'
import InteretForm from '@/views/InteretForm'
import FollowUp from '@/views/FollowUp'
import Error404 from '@/views/Error404'
import ResetPass from '@/views/ResetPass'
import ErrorInactive from '@/views/ErrorInactive'

Vue.use(VueRouter)

const routes = [
  {
    path: '/lang/:lang',
    redirect: to => {
      const { hash, params, query } = to
      if (params.lang){
        store.dispatch('setLang', params.lang)
        return { name: 'Home' }
      }
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: {name: "Operations"}
  },
  {
    path: '/operations',
    name: 'Operations',
    component: Operations
  },
  {
    path: '/operations/:code/todo',
    name: 'Todo',
    component: Todo,
    props: true
  },
  {
    path: '/operations/:code/leads',
    name: 'Leads',
    component: Leads,
    props: true
  },
  {
    path: '/operations/:code/rdv',
    name: 'Rdv',
    component: Rdv,
    props: true
  },
  {
    path: '/operations/:code/rdv/create',
    name: 'CreateRdv',
    component: CreateRdv,
    props: true
  },
  {
    path: '/operations/:code/rdv/:mode/:idLead',
    name: 'AddRdv',
    component: AddRdv,
    props: true
  },
  {
    path: '/operations/:code/medias',
    name: 'Medias',
    component: Medias,
    props: true
  },
  {
    path: '/operations/:code/statistiques',
    name: 'Statistique',
    component: Statistique,
    props: true
  },
  {
    path: '/mon-compte',
    name: 'Account',
    component: Account,
    props: true
  },
  {
    path: '/operations/:code/leads/:id/details',
    name: 'Details',
    component: Details,
    props: true
  },
  {
    path: '/operations/:code/leads/:id/details/donner-suite',
    name: 'FollowUp',
    component: FollowUp,
    props: true
  },
  {
    path: '/operations/:code/leads/:id/reprise/:mode',
    name: 'RepriseForm',
    component: RepriseForm,
    props: true
  },
  {
    path: '/operations/:code/leads/:id/interet/:mode',
    name: 'InteretForm',
    component: InteretForm,
    props: true
  },
  {
    path: '/operations/:code/leads/:id/edit',
    name: 'EditLead',
    component: EditLead,
    props: true
  },
  {
    path: '/operations/:code/leads/create',
    name: 'CreateLead',
    component: CreateLead,
    props: true
  },
  {
    path: '/reset_password/:token',
    name: 'ResetPass',
    component: ResetPass,
    props: true
  },
  {
    path: '/erreur',
    name: 'Error404',
    component: Error404
  },
  {
    path: '/compte-inactif',
    name: 'ErrorInactive',
    component: ErrorInactive
  },
  {
    path: '/:token',
    name: 'ResetPass',
    component: ResetPass,
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//check if authenticated, otherwise go to login route
router.beforeEach((to, from, next) => {
  store.dispatch('setRoute', {to: to, from: from})
  if(to.name !== 'Login' && to.name !== 'Error404' && to.name !== 'ErrorInactive' && to.name !== 'ResetPass' && from.name != 'ResetPass'){
    if (store.state.auth){ next()
    } else{
      store.dispatch('checkLogged', {}).then((e) => {
        if(store.state.user.id){
          store.dispatch('getProjets', {}).then((e) => {
            if (store.state.auth){
              next()
            } else {
              const queryParams = to.params;
              queryParams.redirectFrom = to.path;
              queryParams.redirectName = to.name;
              next({ name: 'Login', query: queryParams })
            }
          })     
        } else {
          const queryParams = to.params;
          queryParams.redirectFrom = to.path;
          queryParams.redirectName = to.name;
          next({ name: 'Login', query: queryParams })
        }
           
      })
    } 
  } else {
    next();
  }
  
})

export default router
